module.exports = __webpack_public_path__ + "static/media/SteeringFpIImageOnlyViz90.0bd9907a.jpg";